var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "grid" } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-light",
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [
          _c("i", { staticClass: "fa-regular fa-building" }),
          _vm._v(" Simulate Bank Transfer"),
        ]
      ),
      _vm._v(" "),
      _vm.isAlertOpen
        ? _c("alert-modal", [
            _c("span", [
              _c("i", { staticClass: "fa-solid fa-circle-check" }),
              _vm._v("Payment sucessfully created"),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("h1", [
                _vm._v("Make Payment"),
                _c("i", {
                  staticClass: "fa-regular fa-xmark",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-weight": "normal", color: "#717182" } },
                [
                  _vm._v(
                    "Submit a payment for this order. All fields are pre-filled but can be edited."
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "grid" } }, [
                _c("span", { staticClass: "filter-item-title" }, [
                  _vm._v("VIBAN*"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.payment.VIBAN,
                      expression: "payment.VIBAN",
                    },
                  ],
                  staticClass: "filter-item-content",
                  attrs: { type: "text", placeholder: "VIBAN..." },
                  domProps: { value: _vm.payment.VIBAN },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.payment, "VIBAN", $event.target.value)
                      },
                      function (event) {
                        return (_vm.payment.VIBAN = _vm.sanitize(
                          event.target.value
                        ))
                      },
                    ],
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "grid" } }, [
                _c("span", { staticClass: "filter-item-title" }, [
                  _vm._v("Amount (EUR)*"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.payment.amount,
                      expression: "payment.amount",
                    },
                  ],
                  staticClass: "filter-item-content",
                  attrs: { type: "number", placeholder: "0.00" },
                  domProps: { value: _vm.payment.amount },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.payment, "amount", $event.target.value)
                      },
                      function (event) {
                        return (_vm.payment.amount = _vm.sanitize(
                          event.target.value
                        ))
                      },
                    ],
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "grid" } },
                [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("Payment Date*"),
                  ]),
                  _vm._v(" "),
                  _c("datetime-picker", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.dateBegin,
                      "error-datepicker": _vm.dateBeginError,
                    },
                    attrs: {
                      format: "DD/MM/YYYY",
                      customInputParentClass: "filter-item-content",
                      maxLength: 19,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                    },
                    model: {
                      value: _vm.dateBegin,
                      callback: function ($$v) {
                        _vm.dateBegin = $$v
                      },
                      expression: "dateBegin",
                    },
                  }),
                  _vm._v(" "),
                  _vm.dateBeginError
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.$t("errors.Data_format_invalid"))),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "grid" } }, [
                _c("span", { staticClass: "filter-item-title" }, [
                  _vm._v("Remittance Reference"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.payment.reference,
                      expression: "payment.reference",
                    },
                  ],
                  staticClass: "filter-item-content",
                  attrs: {
                    type: "text",
                    placeholder: "Payment reference (optional)",
                  },
                  domProps: { value: _vm.payment.reference },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.payment, "reference", $event.target.value)
                      },
                      function (event) {
                        return (_vm.payment.reference = _vm.sanitize(
                          event.target.value
                        ))
                      },
                    ],
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "grid",
                    "grid-template-columns": "1fr 1fr",
                    "align-items": "center",
                    gap: "1rem",
                    "margin-top": "2rem",
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn-outline btn-dark",
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v("Submit Payment")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-outline-light btn",
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }